import {
  CREATE_ACTIVITY_SUCCESS,
  FETCH_ACTIVITY_SUCCESS,
  GET_ACTIVITY_SUCCESS,
  SAVE_ACTIVITY_QUERY
} from "../../constants/ActionTypes";

const INIT_STATE = {
  total: 0,
  resources: [],
  resource: {},
  edit: {},
  query: {},
  // activities: [],
  // activity: {},
  // activityLoading: false,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_ACTIVITY_QUERY: {
      return {
        ...state,
        query: action.query
      }
    }

    case GET_ACTIVITY_SUCCESS: {
      const query = {...state.query};
      query.pagination.total = action.count;

      return {
        ...state,
        query: query,
        resources: action.data,
        total: action.total,
      }
    }

    case CREATE_ACTIVITY_SUCCESS: {
      return {
        ...state,
        resource: action.data,
      }
    }

    case FETCH_ACTIVITY_SUCCESS: {
      return {
        ...state,
        edit: action.data,
      }
    }

    // case GET_TRANSFERABLE_ACTIVITIES: {
    //   return {
    //     ...state,
    //     activities: action.data,
    //   }
    // }
    //
    // case FETCH_ACTIVITY_DETAILS_SUCCESS: {
    //   return {
    //     ...state,
    //     activity: action.data,
    //   }
    // }
    //
    // case FETCH_ACTIVITY_DETAILS_START: {
    //   return {
    //     ...state,
    //     activityLoading: true,
    //   }
    // }
    // case FETCH_ACTIVITY_DETAILS_STOP: {
    //   return {
    //     ...state,
    //     activityLoading: false,
    //   }
    // }
    default:
      return state;
  }
}
